<template>
  <div>
    <div class="decision-glue-block" v-if="decision && check">
      <div class="decision-glue-item">
        <div>
          <span>{{ decision.title }}</span>
          <img v-if="decision.img" :src="decision.img" />
          <span class="ml-2 mr-2 badge badge-info">Группа: {{ decision.group_symbol }}</span>
        </div>
        <div>
          <span>{{ check.title }}</span>
          <img v-if="check.img" :src="check.img" />
          <span class="ml-2 mr-2 badge badge-info">Группа: {{ check.group_symbol }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "text",
  props: {
    decision: {
      default: null,
    },
    check: {
      default: null,
    },
  },

};
</script>


<style lang="scss">
.decision-test {
  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
    margin-right: 10px;
  }
}
</style>

